<template>
  <BCard
    no-body
    class="font-weight-bold w-100"
    :class="
      isHomeworkTimeReserved
        ? 'schedule-card-border-reserved'
        : 'schedule-card-border-free'
    "
  >
    <BCardHeader
      class="text-center d-flex flex-row align-items-center justify-content-between schedule-card-bg-free"
    >
      <h4 class="text-left text-white" style="font-size: 16px">
        تاریخ:
        {{ customFullDateConvert(homeworkDetails.date) }}
      </h4>
      <div class="d-flex flex-row align-items-center">
        <BButton
          @click="renderDeleteHomeworkTimeConfirmationDialog"
          class="p-0"
          variant="transparent"
          size="sm"
          :class="
            isHomeworkTimeReserved ? 'cursor-not-allowed' : 'cursor-pointer'
          "
          :disabled="isHomeworkTimeReserved"
        >
          <FeatherIcon icon="Trash2Icon" class="text-white" size="20" />
        </BButton>
        <BButton
          @click="renderUpdateHomeworkTimeDialog"
          class="p-0 ml-1"
          variant="transparent"
          size="sm"
          :class="
            isHomeworkTimeReserved ? 'cursor-not-allowed' : 'cursor-pointer'
          "
          :disabled="isHomeworkTimeReserved"
        >
          <FeatherIcon icon="EditIcon" class="text-white" size="20" />
        </BButton>
      </div>
    </BCardHeader>
    <BCardText>
      <p class="text-center mt-1 font-weight-bolder">
        روز
        {{ customConvertWeekDay(homeworkDetails.date) }}
      </p>
      <p class="text-center text-info" style="font-weight: bold">
        <span style="text-decoration: underline">{{
          homeworkDetails.masterTimeByMinute
        }}</span>
        دقیقه
      </p>
      <p class="text-center mb-0 font-weight-bolder">توضیحات استاد:</p>
      <p
        class="text-center px-2"
        style="margin-top: 5px; font-size: 13px !important"
      >
        {{ homeworkDetails.description }}
      </p>
    </BCardText>
    <HomeworkTimeDeleteConfirmationDialog
      :dialogId="homeworkDetails.id"
      :selectedHomework="homeworkDetails"
      @refetch="refetch"
    ></HomeworkTimeDeleteConfirmationDialog>
    <UpdateHomeworkTimeDialog
      :dialogId="homeworkDetails.id"
      :defaultHomeworkTime="tempSelectedHomeworkDetails"
      @refetch="refetch"
    ></UpdateHomeworkTimeDialog>
  </BCard>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    homeworkDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tempSelectedHomeworkDetails: null,
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
    renderDeleteHomeworkTimeConfirmationDialog() {
      this.$bvModal.show(
        `delete-homework-time-confirmation-dialog-${this.homeworkDetails.id}`
      );
    },
    renderUpdateHomeworkTimeDialog() {
      this.tempSelectedHomeworkDetails = this.homeworkDetails;
      this.$bvModal.show(
        `update-homework-time-dialog-${this.homeworkDetails.id}`
      );
    },
  },
  computed: {
    isHomeworkTimeReserved() {
      if (
        this.homeworkDetails &&
        this.homeworkDetails.status &&
        this.homeworkDetails.status == 1
      ) {
        return false;
      }
      return true;
    },
  },
  mixins: [timeConvertUtils],
  components: {
    HomeworkTimeDeleteConfirmationDialog,
    UpdateHomeworkTimeDialog,
    BCard,
    BCollapse,
    BCardText,
    BCardHeader,
    BButton,
    BBadge,
  },
};
import HomeworkTimeDeleteConfirmationDialog from "@/views/components/Homeworks/HomeworkTimeDeleteConfirmationDialog.vue";
import UpdateHomeworkTimeDialog from "@/views/components/Homeworks/UpdateHomeworkTimeDialog.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import {
  BCard,
  BCollapse,
  BCardText,
  BCardHeader,
  BButton,
  BBadge,
} from "bootstrap-vue";
</script>
<style scoped>
.schedule-card-bg-free {
  background-color: #007bff;
}
.schedule-card-bg-reserved {
  background-color: #c40000;
}
.schedule-card-border-free {
  border: 1px solid #007bff;
}
.schedule-card-border-reserved {
  border: 1px solid #c40000;
}
</style>
